// removed by extract-text-webpack-plugin
module.exports = {"root":"bWI4xfMWMBB_hIq2S7YTJ","dark":"_1sKHSwoPE3R9Thxd3aIQ5e","logo":"_3xoBSnTOKB15MZHZvIZCUC","navigation":"yN9bWb-OptbMyDVJ8TKEz","active":"vvd4KXWeqcaSwyg_7mop0","light":"_3y3gIsBKlfposMoQP0QH1V","separator":"_282nKWQCPpOYUC0tQoaZWg","muhimma":"_38P0wCeGJ7CFKS4rNO_sfE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/header.scss
// module id = 1525
// module chunks = 0